export const kebabToCamelCase = (
  stepKey: string,
  prefix: string = '',
): string => {
  // First convert kebab-case to camelCase
  const camelCase = stepKey.replace(/-([a-z0-9])/g, (g) => g[1].toUpperCase());

  // Add prefix and capitalize the first letter of the original step
  return prefix + camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};

export default kebabToCamelCase;
